@import 'styles/variables';

.body {
  padding: 35px 40px;
  position: relative;
}

.closeButton {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 6px;
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    background: var(--dark-4, rgba(0, 0, 0, 0.04));
  }
}

.inner {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.headline {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.headlineText {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.title {
  font-size: 26px;
  font-weight: 400;
  line-height: 1.1;
  color: var(--dark-90);
  margin: 0;
}

.subtitle {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--dark-90);
  margin: 0;
}

.providerList {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.providerRow {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 52px;
  padding: 8px 8px 8px 12px;
}

.providerLeft {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.providerIcon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}

.providerName {
  font-size: 16px;
  font-weight: 400;
  color: var(--dark-90);
  line-height: 1.4;
  white-space: nowrap;
}

.providerRight {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.connectedState {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 10px;
}

.connectedCircle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--green, #20a14f);
  flex-shrink: 0;
}

.connectedLabel {
  font-size: 16px;
  font-weight: 400;
  color: var(--green, #20a14f);
  line-height: 1.4;
  white-space: nowrap;
}

.waitingPill {
  display: inline-flex;
  align-items: center;
  padding: 2px 3px;
  border-radius: 4px;
  background: var(--dark-2, rgba(0, 0, 0, 0.02));
  color: var(--dark-90);
  font-size: 12px;
  letter-spacing: 0.24px;
  white-space: nowrap;
}

.divider {
  height: 1px;
  width: 100%;
  background: var(--dark-8, rgba(0, 0, 0, 0.08));
  border: none;
  margin: 0;
}

.navSection {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.navRow {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: fit-content;
  text-align: left;

  &:hover {
    background: var(--dark-2, rgba(0, 0, 0, 0.02));
  }
}

.navLabel {
  font-size: 16px;
  font-weight: 400;
  color: var(--dark-90);
  line-height: 1.4;
}

.navRight {
  display: flex;
  align-items: center;
  gap: 6px;
}

.navDescription {
  font-size: 14px;
  font-weight: 400;
  color: var(--dark-60);
  line-height: 1.4;
  letter-spacing: 0.14px;
  white-space: nowrap;
}
